import { ITag } from '../models/tag';
import { ICustomDataAttribute } from './../models/custom-data/custom-data-attribute';

export namespace Member.Actions {
  export class GetAttributes {
    public static readonly type = '[Member] Get Organization Attributes]';
    constructor(public organizationId) {}
  }

  export class SetTags {
    // Do I need to pass the organizationID
    public static readonly type = '[Member] Set Member Tags]';
    constructor(public memberID: string[], public tags: ITag | string) {}
  }

  export class SetBulkMemberTags {
    // Do I need to pass the organizationID
    public static readonly type = '[Member] Set Bulk Member Tags]';
    constructor(public memberIds: string[], public tag: ITag) {}
  }
  // export class GetApprovers {
  //   public static readonly type = "[Member] Get Organization Transaction Approvers]";
  //   constructor(public organizationId) {}
  // }

  // export class AddCustomAttribute {
  //   public static readonly type = "[Member] Add Custom Attribute]";
  //   constructor(public attribute: ICustomDataAttribute) {}
  // }
}
